import { ILocation } from '../../types/location';
import { IApplicationState } from '../../types/redux';

export const selectLocation = (state: IApplicationState): ILocation | undefined | null => {
  return state.location;
};
